
/**
 * 数字转字母
 * @param {string} num 数字
 */
export const convertASCIIForNum = function(num) {
  let itemCode = '';
  num = num + 65;
  if (num > 64 && num < 91) {
    itemCode = String.fromCharCode(num);
  }
  return itemCode;
};

/**
 * 处理换行符
 * @param {String} txt 文本
 * @param {Boolean} isNotHtml 是否非Html内容
 */
export const dealLineFeed = function(txt, isNotHtml) {
  if (txt) {
    if (isNotHtml) {
      txt = htmlEncode(txt); // 对多行文本就行编码预防xss
    }
    // 去掉所有的换行符
    txt = txt.replace(/\r\n/g, '<br />');
    txt = txt.replace(/\r/g, '<br />');
    txt = txt.replace(/\n/g, '<br />');
  }
  return txt;
};

/**
 * 处理文本、富文本内容
 * @param {String} str 富文本内容
 * @param {Boolean} isInLine 是否需要在行内显示，此时需要处理第一个p
 */
export const cleanStyle = function(str, isInLine) {
  if (!str) {
    return '';
  }
  if (str) {
    if (
      str.indexOf('<p>') === 0 &&
      str.indexOf('<p>') === str.lastIndexOf('<p>')
    ) {
      // 单个纯粹的P, 直接去除。当成纯文本
      str = str.replace('<p>', '').replace('</p>', '');
    } else if (isInLine) {
      // 需要在行内展示的情况： A. ******
      // 处理原P标签，无样式的默认行替换掉第一行实现ABCD插入, 同时处理间距和富文本保持一致
      str = str
        .replace('<p>', '')
        .replace('</p>', '')
        .replace(/<p>/g, '<p class="mv10">');
    } else {
      // 其余情况 去除顶部margin-top来对其，同时处理间距和富文本保持一致
      str = str
        .replace('<p>', '<p class="mt0 mb10">')
        .replace(/<p>/g, '<p class="mv10">');
    }
  }
  // 替换&nbsp; 单个空格留空格 多个每2个替换为 空格+&nbsp;
  let reg1 = /&nbsp;/g;
  let reg2 = / {2}/g;
  if (str) {
    str = str.replace(reg1, ' ');
    str = str.replace(reg2, ' &nbsp;');
  }
  // \r\n 改成<br>自动换行
  let brChange = dealLineFeed(str);
  return brChange;
};

/**
 * html编码
 * @param {String} str 带编码字符串
 */
export const htmlEncode = function(str) {
  if (str === undefined || str === null || str.length === 0) return '';
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/ /g, '&nbsp;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;')
    .replace(/·/g, '&#183;')
    .replace(/\\/g, '\\\\')
    .replace(/%/g, '%25');
};

/**
 * 通用的错误处理方法
 * @param {Object} error 错误信息
 */
export const handleError = function(error) {
  if (error && error.error) {
    // 兼容处理
    error = error.error;
  }
  if (error) {
    if (error.key && error.key.indexOf('global.token') >= 0) {
      return; // 不弹出token错误
    }
    let msg = error.message;
    this.$message({
      message: msg,
      type: 'error'
    });
  }
};
